import {useProgress} from "@react-three/drei";
import './LoadingScreen.scss';
import {motion, useAnimationControls} from "framer-motion";
import {useEffect, useState} from "react";
import balloon from '../assets/spinningballoon.gif';

// HTML <video> doesn't support per-pixel alpha transparency in browsers
// regardless of codec, so a webm here always rendered with an opaque
// (white) background no matter how the source was encoded. An animated
// GIF's transparency is a basic, universally-supported <img> feature, so
// that's used instead.
// `immediate`: skip the 200ms "avoid flash for fast loads" delay below.
// That delay makes sense when this is a Suspense fallback that might
// mount and unmount within a few hundred ms either way - but HomePage
// also renders this directly, gated on its own "is the scene actually
// ready" check, so by the time it decides to render this at all, showing
// it late just opens a gap where the raw page flashes through first.
const LoadingScreen = ({immediate = false}) => {
    const controls = useAnimationControls();
    const progress = useProgress().progress;
    const [show, setShow] = useState(immediate);

    useEffect(() => {
        if (immediate) return;
        const timer = setTimeout(() => setShow(true), 200);
        return () => clearTimeout(timer);
    }, [immediate]);

    useEffect(() => {
        if (show) {
            controls.start({opacity: 1, transition: {duration: 0.4, ease: "easeIn"}});
        }
    }, [show, controls]);

    useEffect(() => {
        if (progress >= 95) {
            controls.start({
                opacity: 0,
                transition: {duration: 0.9, ease: "easeIn", delay: 0.3}
            })
        }
    }, [progress, controls])


    if (progress >= 100) {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        return null;
    }
    if (!show) return null;

    return (
        <div>

            <motion.div className="progress-bar" initial={{opacity: 0}} exit={{opacity: 0}} animate={controls}>
                <img src={balloon} alt="" className={'spinner'}/>
                <h4>{Math.round(progress)}%</h4>
                <div className={"barWrapper"}>
                    <div className={"progress"} style={{width: `${progress}%`}}>
                        <span>.</span>
                    </div>
                </div>
            </motion.div>
        </div>
    )


}

export default LoadingScreen;
